/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberSearchListGroupResponse } from "./MemberSearchListGroupResponse";

export type MemberSearchListGroupResponseApiRespoonse = {
  data?: MemberSearchListGroupResponse;
  status?: MemberSearchListGroupResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MemberSearchListGroupResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
